import { FC, useMemo } from "react"
import classNames from "classnames"
import { Outlet, useLocation } from "react-router"
import Header from "@/components/shared/Header"
import { PageRoutes } from "@/constants/routes"
import "./index.scss"

interface LayoutProps {
   isAuthLayout?: boolean
   className?: string
}

const Layout: FC<LayoutProps> = ({ isAuthLayout = false, className }) => {
   const { pathname } = useLocation()
   const showAlerts = useMemo(() => {
      return pathname !== PageRoutes.CONTROL_PANEL
   }, [pathname])

   return (
      <div
         className={classNames(
            "layout",
            { "layout--auth": isAuthLayout },
            className
         )}
      >
         {isAuthLayout && <Header showAlerts={showAlerts} />}
         <Outlet />
      </div>
   )
}

export default Layout
